import React from 'react';
import Header from '../components/Header';
import HeroBanner from '../home_page/components/HeroBanner';
import StatsSection from './components/StatsSection';
import ManualReplyGenerator from '../home_page/components/ManualReplyGenerator';
import VisionSection from '../home_page/components/VisionSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="ai-v-conic">
      <Header />

      {/* 1. Hero Section */}
      <HeroBanner />

      {/* 2. Manual Generation Card */}
      <ManualReplyGenerator />

      {/* 3. Stats Cards */}
      <StatsSection />

      {/* 4. Vision Cards */}
      <VisionSection />

      <Footer />
    </div>
  );
};

export default HomePage;
